import { render } from "./AnnotationEditorGallery.vue?vue&type=template&id=233d0b58&scoped=true"
import script from "./AnnotationEditorGallery.vue?vue&type=script&lang=js"
export * from "./AnnotationEditorGallery.vue?vue&type=script&lang=js"

import "./AnnotationEditorGallery.vue?vue&type=style&index=0&id=233d0b58&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233d0b58"]])

export default __exports__